import { Alert, AlertDescription } from "./ui/alert";
import { Button } from "./ui/button";
import { Mail, X } from "lucide-react";
import { useState } from "react";

interface EmailVerificationBannerProps {
  onResendEmail?: () => void;
  onDismiss?: () => void;
}

export function EmailVerificationBanner({ onResendEmail, onDismiss }: EmailVerificationBannerProps) {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss?.();
  };

  return (
    <Alert className="border-warning/30 bg-warning/10 mb-6">
      <Mail className="h-4 w-4 text-warning" />
      <AlertDescription className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2 text-warning-900">
          <span>
            <strong>Almost there!</strong> Please confirm your email so Chef Lex can send your weekly meal plans.
          </span>
        </div>
        <div className="flex items-center gap-2 ml-4">
          <Button 
            variant="warning" 
            size="sm" 
            onClick={onResendEmail}
            className="text-sm"
          >
            Resend Email
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleDismiss}
            className="text-warning hover:bg-warning/10"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
